export function getSuggestPos(editor){
	const text = editor.getValue();
	const node = editor.getInputNode();

	const sizes = webix.html.offset(node);

	const selectionStart = node.selectionStart;
	const textWidth = webix.html.getTextSize(text.substring(0, selectionStart), "webix_ssheet_formula").width;

	return {
		x: sizes.x + textWidth,
		y: sizes.y + sizes.height
	};
}